/**
 * Hook to determine if the current user has access to multiple branches.
 */
import {useGetCurrentUserInfoQuery} from '@dms/api/customer';

export const useHasMultipleBranches = () => {
  const {data: userInfo} = useGetCurrentUserInfoQuery();

  const branchCount = userInfo?.branches?.length ?? 0;

  const hasMultipleBranches = branchCount > 1;

  return {
    hasMultipleBranches,
    branchCount,
  };
};
